import _ from 'lodash';
import { BUYABLE_TYPE, useCalculateGrossPrice } from '@fiverr-private/price_upfront_components';
import type { Currency } from '@fiverr-private/currencies_plugin';
import { logger } from '@fiverr-private/obs';

interface UseDisplayPriceProps {
    originalPrice?: number | string;
    hourlyRate?: number | string;
    showHourlyPrice?: boolean;
    currency?: Currency;
}

export const useDisplayPrice = ({
    originalPrice,
    hourlyRate,
    showHourlyPrice = false,
    currency,
}: UseDisplayPriceProps) => {
    if (_.isUndefined(originalPrice) && _.isUndefined(hourlyRate)) {
        logger.error('useDisplayPrice: Either originalPrice or hourlyRate must be provided');
        throw new Error('useDisplayPrice: Either originalPrice or hourlyRate must be provided');
    }

    const buyableType = showHourlyPrice ? BUYABLE_TYPE.HOURLY : BUYABLE_TYPE.GIG;
    const netPriceInUSD = Number(showHourlyPrice ? hourlyRate : originalPrice);
    const grossPriceInUSD = useCalculateGrossPrice(netPriceInUSD, buyableType);
    const displayPrice = currency?.rate
        ? Math.ceil(grossPriceInUSD * Number(currency.rate))
        : Math.ceil(grossPriceInUSD);
    const showTooltip = netPriceInUSD !== grossPriceInUSD;

    return { buyableType, netPriceInUSD, grossPriceInUSD, displayPrice, showTooltip };
};
